import WebView from "./LeaderWebView"
import MobileView from "./LeaderMobileview"
import { useMediaQuery } from "@mui/material"
export default function Leader(){
    const isSmallScreen = useMediaQuery('(max-width:960px)')
       return (
           <> 
           {
               isSmallScreen ?
               <MobileView/> 
               :
               <WebView/>
           }
           </>
    )
}